import { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { BsSearch } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";
import logo from "../../images/logo.png";
import Clock from "./Clock";
import StatusBar from "./StatusBar";
import { useAppContext } from "../../context/appContext";

const Navbar = (props) => {
    const { user, logoutUser, toggleModal } = useAppContext();
    const [name, setName] = useState(null);

    useEffect(() => {
        if (user) {
            setName(user.name);
        }
    }, [user]);

    const toggleModalHandler = (event) => {
        toggleModal("", "search");
    };

    return (
        <>
            <div className='h-[5rem]  w-full bg-main-700'>
                <div className='flex h-full  items-center justify-between'>
                    <div className='flex items-center justify-center px-4'>
                        <FaBars className='cursor-pointer text-3xl' />
                        {/* <FaTimes /> */}

                        <p className='brand-title'>barizdev</p>
                        <p className='h-full font-normal	'>
                            <span className=' text-xl'>{name} </span>- <Clock />
                        </p>
                    </div>
                    <div className='flex items-center px-4'>
                        <BsSearch
                            onClick={toggleModalHandler}
                            className='mx-4 cursor-pointer text-2xl'
                        />

                        <BiLogOut onClick={logoutUser} className='mx-2 cursor-pointer text-3xl' />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;
